<div class="cdw-autocomplete-container" [ngClass]="{'hide-main-input': hideMainInput}">
  <!-- Input field -->
  <mat-form-field
    [hideRequiredMarker]="hideRequiredMarker"
    [floatLabel]="floatLabel"
    class="autocomplete-form-field w-full"
  >
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input
      #triggerInput
      [disabled]="disabled"
      [value]="getInputDisplayValue()"
      (input)="handleInputTyping($event)"
      (click)="openDropdown()"
      (focus)="openDropdown()"
      type="text"
      [placeholder]="placeholder"
      [readonly]="showInternalSearch || multiSelect"
      matInput
      [matAutocomplete]="autocomplete"
      [attr.data-lpignore]="disableLastPass ? 'true' : null"
      [attr.autocomplete]="disableLastPass ? 'new-password' : null"
    />
  </mat-form-field>

  <!-- Autocomplete dropdown -->
  <mat-autocomplete
    [displayWith]="getDisplayText"
    (optionSelected)="handleSingleSelection($event)"
    #autocomplete="matAutocomplete"
    class="cdw-autocomplete-panel"
  >
    <div class="panel-wrapper">
      <!-- Internal search (optional) -->
      <div *ngIf="showInternalSearch" class="internal-search-container">
        <div class="internal-search-field">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            class="search-input"
            [(ngModel)]="searchText"
            (input)="handleSearchFieldChange(searchText)"
            placeholder="Search..."
            type="text"
            [style.font-size]="fontSize"
            [style.font-weight]="fontWeight"
            [style.color]="fontColor"
            [style.font-family]="fontFamily"
            [attr.data-lpignore]="disableLastPass ? 'true' : null"
            [attr.autocomplete]="disableLastPass ? 'new-password' : null"
          />
        </div>
        <mat-divider></mat-divider>
      </div>

      <!-- Options list -->
      <div class="options-container" [style.max-height.px]="dropdownHeight">
        <ng-container *ngIf="filteredOptions | async as options">
          <!-- Regular options -->
          <mat-option
            *ngFor="let option of options"
            [disabled]="multiSelect ? true : option.disabled"
            [value]="option"
          >
            <div class="option-content" (click)="handleOptionClick(option, $event)">
              <!-- Checkbox for multiple selections -->
              <lib-cdw-checkbox *ngIf="multiSelect" [checked]="isItemSelected(option)"></lib-cdw-checkbox>
              <!-- Radio button for single selection -->
              <lib-cdw-radio-button
                *ngIf="!multiSelect"
                [checked]="isItemSelected(option)"
                [value]="option.value"
                [name]="label || placeholder || 'autocomplete'"
              ></lib-cdw-radio-button>
              <span
                class="option-text"
                [style.font-size]="fontSize"
                [style.font-weight]="fontWeight"
                [style.color]="fontColor"
                [style.font-family]="fontFamily"
              >
                <ng-container
                  *ngIf="option.displayName && option.displayName.includes('(user collection)'); else normalText"
                >
                  {{ option.displayName.substring(0, option.displayName.indexOf('(user collection)')) }}
                  <span style="font-style: italic">(user collection)</span>
                </ng-container>
                <ng-template #normalText>
                  {{ option.displayName }}
                </ng-template>
              </span>
              <!-- Optional action link -->
              <a
                *ngIf="option.showDetailsAction"
                class="option-action-link hover-action"
                (click)="handleActionClick(option, $event)"
                [style.font-size]="fontSize || '14px'"
              >
                {{ option.showDetailsAction.label || 'See details' }}
              </a>
            </div>
          </mat-option>

          <!-- Hidden option to keep panel open when no results -->
          <mat-option *ngIf="!options || options.length === 0" style="display: none" [disabled]="true">
            Keep Open
          </mat-option>

          <!-- No results message -->
          <div *ngIf="!options || options.length === 0" class="no-results">
            <mat-icon>search_off</mat-icon>
            <span>No results found</span>
          </div>
        </ng-container>
      </div>

      <!-- Action buttons for multiple selections -->
      <div *ngIf="multiSelect" class="action-button">
        <lib-cdw-button level="primary" mode="small" (buttonClick)="finishMultipleSelection()"> Done </lib-cdw-button>
      </div>
    </div>
  </mat-autocomplete>
</div>
